var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEvents = function SvgEvents(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "events_svg2__a",
    x1: 85.63,
    x2: 256.54,
    y1: 260.07,
    y2: 113.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#events_svg2__a",
    id: "events_svg2__b",
    x1: 66.83,
    x2: 237.74,
    y1: 238.13,
    y2: 91.68
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#events_svg2__a",
    id: "events_svg2__c",
    x1: -4.23,
    x2: 166.69,
    y1: 155.2,
    y2: 8.75
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#events_svg2__a",
    id: "events_svg2__d",
    x1: 1.6,
    x2: 172.52,
    y1: 162,
    y2: 15.55
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#events_svg2__a",
    id: "events_svg2__e",
    x1: 13.95,
    x2: 184.87,
    y1: 176.41,
    y2: 29.97
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#events_svg2__a",
    id: "events_svg2__f",
    x1: -19.57,
    x2: 151.35,
    y1: 137.29,
    y2: -9.15
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#events_svg2__a",
    id: "events_svg2__g",
    x1: -7.22,
    x2: 163.7,
    y1: 151.71,
    y2: 5.26
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#events_svg2__a",
    id: "events_svg2__h",
    x1: 26.3,
    x2: 197.22,
    y1: 190.83,
    y2: 44.38
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#events_svg2__a",
    id: "events_svg2__i",
    x1: 5.14,
    x2: 176.05,
    y1: 166.13,
    y2: 19.68
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M165.62 193.75h-12.5c-1.73 0-3.13 1.4-3.13 3.13s1.4 3.12 3.13 3.12h12.5c1.73 0 3.13-1.4 3.13-3.12s-1.4-3.13-3.13-3.13",
    style: {
      fill: "url(#events_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194.67 171.49-3.66-3.66c-2.23-2.23-3.5-5.31-3.5-8.46v-18.75c0-12.22-7.84-22.61-18.75-26.48v-4.77c0-5.17-4.21-9.37-9.38-9.37s-9.37 4.2-9.37 9.37v4.77c-10.91 3.87-18.75 14.26-18.75 26.48v18.75c0 3.15-1.27 6.23-3.5 8.46l-3.66 3.66c-3.39 3.39-5.34 8.09-5.34 12.88 0 1.73 1.4 3.12 3.13 3.12h12.5c1.73 0 3.13-1.4 3.13-3.12s-1.4-3.12-3.13-3.12h-8.95c.54-2 1.6-3.86 3.08-5.34l3.66-3.66c3.39-3.39 5.33-8.08 5.33-12.88v-18.75c0-12.06 9.81-21.87 21.87-21.87s21.88 9.81 21.88 21.87v18.75c0 4.79 1.95 9.49 5.34 12.88l3.66 3.66c1.48 1.48 2.54 3.33 3.08 5.34h-46.45c-1.73 0-3.13 1.4-3.13 3.12s1.4 3.12 3.13 3.12h50c1.73 0 3.13-1.4 3.13-3.12 0-4.79-1.94-9.49-5.33-12.88Zm-32.17-58.8c-1.03-.11-2.07-.18-3.13-.18s-2.1.07-3.12.18v-3.31a3.124 3.124 0 0 1 6.25 0z",
    style: {
      fill: "url(#events_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.37 175H15.62c-5.17 0-9.37-4.21-9.37-9.37V62.5h134.37c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12H6.25V34.38c0-5.17 4.2-9.37 9.37-9.37h12.5v6.25c0 6.89 5.6 12.5 12.5 12.5h6.25c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.13-3.12-3.13h-6.25c-3.45 0-6.25-2.81-6.25-6.25V12.5c0-3.45 2.81-6.25 6.25-6.25s6.25 2.8 6.25 6.25v6.25h-3.12c-1.73 0-3.13 1.4-3.13 3.12S42.02 25 43.75 25h65.62v6.25c0 6.89 5.61 12.5 12.5 12.5h6.25c1.73 0 3.13-1.4 3.13-3.12s-1.4-3.13-3.13-3.13h-6.25c-3.45 0-6.25-2.81-6.25-6.25V12.5c0-3.45 2.81-6.25 6.25-6.25s6.25 2.8 6.25 6.25v6.25H125c-1.73 0-3.12 1.4-3.12 3.12S123.28 25 125 25h21.88c5.17 0 9.37 4.2 9.37 9.37v56.25c0 1.73 1.4 3.12 3.12 3.12s3.13-1.4 3.13-3.12V34.37c0-8.62-7.01-15.62-15.62-15.62h-12.5V12.5c0-6.89-5.6-12.5-12.5-12.5s-12.5 5.61-12.5 12.5v6.25H53.13V12.5c0-6.89-5.61-12.5-12.5-12.5s-12.5 5.61-12.5 12.5v6.25h-12.5C7.01 18.75.01 25.76.01 34.37v131.25c0 8.62 7.01 15.62 15.62 15.62h93.75c1.73 0 3.12-1.4 3.12-3.13s-1.4-3.12-3.12-3.12Z",
    style: {
      fill: "url(#events_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5 90.63H50a3.124 3.124 0 0 0 0 6.25h62.5c1.73 0 3.13-1.4 3.13-3.13s-1.4-3.12-3.13-3.12",
    style: {
      fill: "url(#events_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5 115.62H50c-1.72 0-3.12 1.4-3.12 3.13s1.4 3.12 3.12 3.12h62.5c1.73 0 3.13-1.4 3.13-3.12s-1.4-3.13-3.13-3.13",
    style: {
      fill: "url(#events_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.25 84.38c-5.17 0-9.37 4.2-9.37 9.37s4.21 9.38 9.37 9.38 9.37-4.21 9.37-9.38-4.2-9.37-9.37-9.37m0 12.5c-1.72 0-3.12-1.4-3.12-3.13s1.4-3.12 3.12-3.12a3.124 3.124 0 0 1 0 6.25",
    style: {
      fill: "url(#events_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.25 109.37c-5.17 0-9.37 4.21-9.37 9.38s4.21 9.37 9.37 9.37 9.37-4.21 9.37-9.37-4.2-9.38-9.37-9.38m0 12.51a3.124 3.124 0 0 1 0-6.25c1.72 0 3.12 1.4 3.12 3.13s-1.4 3.12-3.12 3.12",
    style: {
      fill: "url(#events_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5 140.62H50c-1.72 0-3.12 1.4-3.12 3.13s1.4 3.12 3.12 3.12h62.5c1.73 0 3.13-1.4 3.13-3.12s-1.4-3.13-3.13-3.13",
    style: {
      fill: "url(#events_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.25 134.38c-5.17 0-9.37 4.2-9.37 9.37s4.21 9.37 9.37 9.37 9.37-4.21 9.37-9.37-4.2-9.37-9.37-9.37m0 12.49a3.124 3.124 0 0 1 0-6.25c1.72 0 3.12 1.4 3.12 3.13s-1.4 3.12-3.12 3.12",
    style: {
      fill: "url(#events_svg2__i)"
    }
  }));
};
export default SvgEvents;